import { get } from "lodash";

const styles = (theme) => ({
  content: {
    margin: 36,
    backgroundColor: get(theme, 'color.uiBackground'),
    marginTop: 0,
    padding: '24px 46px 66px 46px',
    '& button': {
      '&:focus': {
        outlineWidth: '1px !important',
        outlineOffset: '1px !important',
      },
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  flexNonAlign: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  flexNonBetween: {
    display: 'flex',
    alignItems: 'center',
  },
  cautionIcon: {
    marginTop: '1rem',
    marginLeft: 10,
    width: 25,
  },
  orderedList: {
    color: `${get(theme, 'color.bodyText')} !important`,
  },
  requirementsTitle: {
    textTransform: 'capitalize',
  },
  list: {
    marginTop: 5,
  },
  alertDialogTitle: {
    textTransform: 'capitalize',
    marginLeft: 5,
    fontSize: 18,
  },
  alertDialogDescription: {
    marginBottom: 10,
  },
  formDialogCell: {
    width: 300,
    height: 35,
  },
  formDialogCellContent: {
    paddingTop: 10,
  },
  actionFormDialogCell: {
    marginTop: -10,
  },
  formDialogNone: {
    paddingTop: 10,
    color: get(theme, "fontSize.bodyText"),
  },
  textButton: {
    border: "1px solid green",
    padding: 0,
    margin: 0,
    width: 10,

  },
  formDialogContainer: {
    maxWidth: '900px !important',
  },
  formDialogIcon: {
    marginRight: 10,
  },
  formDialogHead: {
    fontWeight: "bold",
  },
  listToolTip: {
    width: 25,
    marginLeft: 12,
    marginTop: 5,
  },
  alertContainer: {
    width: "90%",
  },
})

export default styles;